<template>
	<div :id="modalName">
		<b-modal :id="modalName" :title="'Build Kit - ' + sku" size="lg" scrollable hide-footer>
            <b-form-row>
                <b-col>
                    <b-form-group
                        id="datepicker-group-date"
                        label="Date:"
                        label-for="datepicker-date"
                        label-size="sm"
                    >
                        <b-form-datepicker
                            id="datepicker-date"
                            v-model="create.date"
                            class="mb-2"
                            size="sm"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            locale="en"
                        >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <!-- <b-col>
                    <b-form-group
                        id="input-group-cost"
                        label="Cost:"
                        label-for="input-cost"
                        label-size="sm"
                    >
                        <b-form-input
                            id="input-cost"
                            v-model="create.cost"
                            type="text"
                            size="sm"
                            autocomplete="off"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col> -->
                <b-col>
                    <b-form-group
                        id="input-group-qty"
                        label="Quantity:"
                        label-for="input-qty"
                        label-size="sm"
                    >
                        <b-form-input
                            id="input-qty"
                            v-model="create.qty"
                            type="text"
                            size="sm"
                            autocomplete="off"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                        id="input-group-location"
                        label="Location:"
                        label-for="input-location"
                        label-size="sm"
                    >
                        <b-form-select
                            id="select-location"
                            v-model="create.location"
                            :options="Object.keys(getLocations)"
                            size="sm"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <hr>
            <b-table-simple hover small caption-top bordered responsive>
                <b-thead head-variant="dark">
                    <b-tr>
                        <b-th>Component SKU</b-th>
                        <b-th class="text-center">QTY</b-th>
                        <b-th class="text-center">WAC</b-th>
                        <b-th class="text-center">Total</b-th>
                        <b-th class="text-center">QOH</b-th>
                        <b-th class="text-center">Available</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(comp, index) in components" :key="index">
                        <b-td>{{ comp.line_item.sku }}</b-td>
                        <b-td class="text-center">{{ comp.quantity }}</b-td>
                        <b-td class="text-center">${{ comp.line_item.weighted_cost }}</b-td>
                        <b-td class="text-center">${{ (comp.line_item.weighted_cost * comp.quantity).toFixed(2) }}</b-td>
                        <b-td class="text-center">{{ comp.line_item.qty_total }}</b-td>
                        <b-td class="text-center">{{ comp.line_item.qty_available }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td></b-td>
                        <b-td class="text-center"><strong>Total: </strong></b-td>
                        <b-td class="text-center"><strong>${{ wac }}</strong></b-td>
                        <b-td class="text-center"><strong>${{ totalLineWac }}</strong></b-td>
                        <b-td></b-td>
                        <b-td></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <hr>
            <b-button type="submit" variant="success" @click="buildKit">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Building...
                </span>
                <span v-else>Build</span>
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [
            'sku',
            'components',
            'id'
        ],

        components: {

        },

		data() {
			return {
                modalName: 'modal-inventory-products-build-kit',

                create: {
                    date: this.getDate(),
                    // cost: 0.00,
                    location: 'BSG',
                    qty: 1,
                    sku: '',
                    id: ''
                },

                submitting: 0
			}
		},

		methods: {
            buildKit() {
                this.submitting = 1
                let createData = this.create

                let url = 'api/inventory/products/buildkit'
                axios.post(url, {
                    createData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Kit Built', 'SKU: ' + this.create.sku + ' built with ' + this.create.qty + ' quantity successfully!')
                        this.$emit('getRow')
                    } else {
                        this.showAlertBox('error', 'Error Building Kit', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            }
        },

        computed: {
            wac() {
                let total = Number(0)
                this.components.forEach((line, idx, array) => {
                    total += +line.line_item.weighted_cost
                })

                return total.toFixed(2)
            },

            totalLineWac() {
                let total = Number(0)
                this.components.forEach((line, idx, array) => {
                    total += +line.line_item.weighted_cost * +line.quantity
                })

                return total.toFixed(2)
            }
        },

        mounted() {
            // this.create.cost = this.cost
            this.create.sku = this.sku
            this.create.id = this.id
        }
	}
</script>

<style lang="scss">
    #modal-inventory-products-build-kit {
        .modal-dialog {
            min-height: 450px;
        }
    }
</style>
